export const deviceIdKey = 'ngplus_deviceid'
export const uuidKey = 'nfplus_uuid'

export function genUuid () {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (t) {
    var e = (16 * Math.random()) | 0
    return (t === 'x' ? e : (3 & e) | 8).toString(16)
  })
}

export function getDeviceId () {
  let deviceId = localStorage.getItem(deviceIdKey)
  if (!deviceId) {
    deviceId = genUuid()
    localStorage.setItem(deviceIdKey, deviceId)
  }

  return deviceId
}

export function getUUID () {
  let uuid = localStorage.getItem(uuidKey)
  if (!uuid) {
    uuid = genUuid()
    localStorage.setItem(uuidKey, uuid)
  }

  return uuid
}
